import React from "react";
import ReactPaginate from "react-paginate";

/**
 * Consistent bottom-right pagination for list/table pages (react-paginate).
 */
export default function ListPagination({
  pageCount,
  onPageChange,
  isMobileView,
  forcePage,
}) {
  return (
    <div className="mt-8 flex w-full justify-end">
      <ReactPaginate
        nextLabel="Next"
        previousLabel="Back"
        breakLabel="..."
        breakClassName="break-me"
        pageCount={pageCount}
        marginPagesDisplayed={isMobileView ? 1 : 2}
        pageRangeDisplayed={isMobileView ? 1 : 5}
        onPageChange={onPageChange}
        {...(forcePage !== undefined ? { forcePage } : {})}
        containerClassName="pagination flex flex-wrap items-center gap-2"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        nextClassName="page-item"
        previousLinkClassName="page-link"
        nextLinkClassName="page-link"
        disabledClassName="disabled"
        activeClassName="active"
      />
    </div>
  );
}
